import { gql } from "graphql-request";
import { requestAndFormat } from "../utils";

export const createSubitemMutation = (params: {
	parentItemId: string;
	itemName: string;
	columnValues: string;
}) =>
	requestAndFormat(
		{
			defaultParams: {},
			gql: gql`
				mutation CreateSubitem(
					$parentItemId: ID!,
					$itemName: String!
					$columnValues: JSON!,
				) {
					create_subitem (parent_item_id: $parentItemId, item_name: $itemName, column_values: $columnValues) {
						id
					}
				}`,
			skipMondayFormatting: true,
			resultKey: "create_subitem",
			outType: {} as { id: string },
		},
		params,
	);
